import script from "./AiBusinessDirectory.vue?vue&type=script&setup=true&lang=js"
export * from "./AiBusinessDirectory.vue?vue&type=script&setup=true&lang=js"

import "./AiBusinessDirectory.vue?vue&type=style&index=0&id=4bea0b98&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/cs/cs-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bea0b98"]])

export default __exports__